class Utils {
	static formatToCurrency = (amount: any) =>
		amount
			.toFixed(2)
			.replace(/\d(?=(\d{3})+\.)/g, "$&,")
			.replace(".00", "");
}

export default Utils;
